import {
  Button,
  InputAdornment,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import PhoneIcon from "@mui/icons-material/Phone";
import DataContext from "../../context/DataContext";
const Login = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ values: {}, mode: "onBlur" });
  const { validatePhoneNumber, navigator } = useContext(DataContext);

  const onSubmit = (data) => {
    sessionStorage.setItem("phone", data.phone);
    navigator("/verfiy");
  };
  const onError = (event) => {};
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div class="login-page">
      <div class="container-fluid">
        <div className="row justify-content-center align-items-center">
          <div
            className="col-lg-6 col-md-6 col-12 p-0"
            style={isMobile ? { display: "none" } : { display: "block" }}
          >
            <img
              src="/images/auth-bg.png"
              alt="IMG"
              className="img-fluid login-img"
            />
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="">
              <img
                src="/images/govt.png"
                alt=""
                className="img-fluid logo-img mb-2"
              />
              <img
                src="./images/YF_transparent.png"
                className="img-fluid ml-auto logo-img"
                alt=""
              />
            </div>

            <form
              className={isMobile ? "validate-form" : "validate-form p-5"}
              onSubmit={handleSubmit(onSubmit, onError)}
            >
              <div className="row justify-content-center text-center login-form mx-5">
                <div className="col-lg-12 col-md-12 col-12">
                  <h3 class="login100-form-title mb-5">Login / Join Now</h3>
                </div>
                <div className="col-lg-8 col-md-8 col-12">
                  <div className="form-group">
                    <div className="d-flex align-items-center justify-content-center">
                      <Controller
                        name="phone"
                        control={control}
                        defaultValue=""
                        rules={{
                          required: "Mobile Number is required",
                          validate: validatePhoneNumber,
                        }}
                        render={({ field }) => (
                          <TextField
                            variant="outlined"
                            label="Mobile Number"
                            placeholder="Enter Mobile Number"
                            fullWidth
                            type="text"
                            {...field}
                            error={!!errors.phone}
                            inputProps={{ maxLength: 10 }}
                            helperText={errors.phone?.message}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <PhoneIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-8 col-md-8 col-12">
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                      mt: 2,
                      py: 1.5,
                      textTransform: "none",
                      background: "#dd1818",
                    }}
                  >
                    Send OTP
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
